<h2 mat-dialog-title>
  {{ data.mode === 'conditions' ? 'Условия' : 'Награды' }} —
  {{ data.raffle.name }} (#{{ data.raffle.id }})
</h2>
<mat-dialog-content>
  <p>
    Пользователь {{ data.userId }} ·
    {{ data.raffle.raffleFinish ? 'Раффл завершён' : 'Раффл не завершён' }}
  </p>
  <mat-progress-bar
    *ngIf="loading || busy"
    mode="indeterminate"
  ></mat-progress-bar>
  <p *ngIf="error" class="error" role="alert">
    {{ error }}
    <button mat-button (click)="load()" [disabled]="loading || busy">
      Обновить
    </button>
  </p>
  <ng-container *ngIf="data.mode === 'conditions'">
    <table *ngIf="!loading && !error">
      <thead>
        <tr>
          <th>ID связи / условия</th>
          <th>Условие</th>
          <th>Параметры</th>
          <th>Выполнено</th>
          <th>Conditions count</th>
          <th>Действия</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let row of conditions">
          <td>{{ row.id }} / {{ row.condition.id }}</td>
          <td>
            {{ row.condition.name }}
            <p>{{ row.condition.description }}</p>
            <small>{{ row.type }} · {{ row.condition.actionType }}</small>
          </td>
          <td>
            <div>
              Значение: {{ row.condition.value ?? '—' }} · Количество:
              {{ row.condition.count ?? '—' }}
            </div>
            <div>Item ID: {{ row.condition.itemId ?? '—' }}</div>
            <div>
              Опыт от: {{ row.minRaffleExp ?? '—' }} · до:
              {{ row.maxRaffleExp ?? '—' }}
            </div>
            <div>
              Upgrade points: {{ row.upgradePoints ?? '—' }} · Лимит:
              {{ row.limitCompletion ?? '—' }}
            </div>
          </td>
          <td>{{ weights[row.id] > 0 ? 'Да' : 'Нет' }}</td>
          <td>{{ weights[row.id] ?? 0 }}</td>
          <td>
            <ng-container *ngIf="data.canEdit && !data.raffle.raffleFinish">
              <button
                mat-button
                color="primary"
                [disabled]="busy"
                (click)="change(row, false)"
              >
                {{ weights[row.id] > 0 ? 'Изменить вес' : 'Засчитать' }}
              </button>
              <button
                mat-button
                color="warn"
                [disabled]="busy || !weights[row.id]"
                (click)="change(row, true)"
              >
                Снять условие
              </button>
            </ng-container>
          </td>
        </tr>
      </tbody>
    </table>
    <p *ngIf="!loading && !error && !conditions.length">Условий нет.</p>
  </ng-container>
  <ng-container *ngIf="data.mode === 'rewards'">
    <p>
      Статус отражает результат розыгрыша. Факт зачисления награды проверяется
      отдельно.
    </p>
    <table *ngIf="!loading && !error">
      <thead>
        <tr>
          <th>ID связи / награды</th>
          <th>Награда</th>
          <th>Тип</th>
          <th>Значение / фиксированная цена</th>
          <th>Item ID</th>
          <th>Результат пользователя</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let row of rewards">
          <td>{{ row.id }} / {{ row.reward.id }}</td>
          <td>{{ rewardName(row) }}</td>
          <td>{{ row.reward.type }}</td>
          <td>
            {{ row.reward.value ?? '—' }} / {{ row.fixPrice ?? '—' }}
            <div>
              Опыт от {{ row.minRaffleExp ?? '—' }} до
              {{ row.maxRaffleExp ?? '—' }}
            </div>
          </td>
          <td>{{ row.reward.itemId ?? '—' }}</td>
          <td>
            {{
              won(row)
                ? 'Победитель'
                : data.raffle.raffleFinish
                ? 'Не выиграл'
                : 'Не разыграно для пользователя'
            }}
          </td>
        </tr>
      </tbody>
    </table>
    <p *ngIf="!loading && !error && !rewards.length">Наград нет.</p>
  </ng-container>
</mat-dialog-content>
<mat-dialog-actions align="end"
  ><button mat-button [disabled]="busy" [mat-dialog-close]="changed">
    Закрыть
  </button></mat-dialog-actions
>
